import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";

import Home from "./Home";
import About from "./About";
import Contact from "./Contact";
import ProductDetail from "./ProductDetail";
import Checkout from "./Checkout";
import CartDrawer from "./CartDrawer";
import Header from "./Header"; // ✅ Responsive header

import "./App.css";

function App() {
  const [cartItems, setCartItems] = useState([]);
  const [cartOpen, setCartOpen] = useState(false);

  const addToCart = (product, size, quantity) => {
    const existingIndex = cartItems.findIndex(
      (item) => item.product.id === product.id && item.size === size
    );

    const updatedCart = [...cartItems];
    if (existingIndex >= 0) {
      updatedCart[existingIndex].quantity += quantity;
    } else {
      updatedCart.push({ product, size, quantity });
    }

    setCartItems(updatedCart);
    setCartOpen(true);
  };

  const removeFromCart = (index) => {
    const updatedCart = [...cartItems];
    updatedCart.splice(index, 1);
    setCartItems(updatedCart);
  };

  return (
    <>
      <Header cartItems={cartItems} onCartClick={() => setCartOpen(true)} />

      <CartDrawer
        cartItems={cartItems}
        cartOpen={cartOpen}
        onClose={() => setCartOpen(false)}
        onRemove={removeFromCart}
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/product/:id"
          element={<ProductDetail addToCart={addToCart} />}
        />
        <Route path="/checkout" element={<Checkout cartItems={cartItems} />} />
      </Routes>
    </>
  );
}

export default App;